import { render } from "./ProjectsSectionEditor.vue?vue&type=template&id=e900d972"
import script from "./ProjectsSectionEditor.vue?vue&type=script&lang=js"
export * from "./ProjectsSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__